<template>
  <div :class="['dialog-header', { separator }]">
    <slot />
  </div>
</template>

<style lang="postcss" scoped>
.dialog-header {
  &.separator {
    @apply border-b-hairline border-b-support-light;
  }
}
</style>

<script>
export default {
  name: 'DialogHeaderComponent',

  props: {
    separator: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
